<template>
<!-- This example requires Tailwind CSS v2.0+ -->
<div class="fixed z-10 inset-0 overflow-y-auto" :class="showModal?'':'hidden'" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div class="inline-block align-bottom bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-700px w-full">

    <section class="p-3 border-b border-gray-800">
      <div class="flex justify-between">
        <h4 class="text-white text-sm font-bold uppercase mb-3">{{ ProviderName }}</h4>
        <button type="button" class="close" @click.prevent="toggleModal"><span>×</span></button>
      </div>
    </section>

    <section>
      <div class="flex p-2">
        <div class="w-1/3 p-2 border-gray-800 border-r">
          <label for="">Logo</label>
            <div class="upload-box">
                <span v-if="logo == null">This provider has no logo yet...</span>
                <img v-if="logo != null" :src="logo" class="logo-img">
            </div>
        </div>
        <div class="w-2/3 p-2">

          <div class="py-2 flex">
            <h5 class="text-white font-bold mr-2">Provider name:</h5>
            <h5 class="text-white">{{ ProviderName }}</h5>
          </div>

          <div class="py-2 flex">
            <h5 class="text-white font-bold mr-2">Country:</h5>
            <h5 class="text-white">{{ ProviderCountry }}</h5>
          </div>
          <div class="py-2 flex">
            <h5 class="text-white font-bold mr-2">Postal Code:</h5>
            <h5 class="text-white">{{ PostalCode }}</h5>
          </div>

        <div class="py-2 flex">
          <h5 class="text-white font-bold mr-2">City:</h5>
          <h5 class="text-white">{{ City }}</h5>
        </div>

        <div class="py-2 flex">
          <h5 class="text-white font-bold mr-2">Street:</h5>
          <h5 class="text-white">{{ Street }}</h5>
        </div>

        </div>
      </div>
    </section>

    <AssociatedTours
    :provider="current_provider" />

    <div class="p-2">
      <button @click="leaveProvider" class="btn btn-black my-2 float-right">
          <i class="logout mr-2"></i>Leave Provider
      </button>
    </div>

    </div>
  </div>
</div>
</template>

<script>
import AssociatedTours from './AssociatedTours'

export default {
  props: ['showModal', 'toggleModal', 'provider_id'],
  components: {
    AssociatedTours
  },
  data(){
    return{
      current_provider: null,
      ProviderName: null,
      ProviderCountry: null,
      PostalCode: null,
      City: null,
      Street: null,
      logo: null,
      form: this.$inertia.form({
          _method: 'POST',
      }),
      leaveProviderFormIdentifier: null,
    }
  },
  watch:{
    provider_id:function( newState, oldState ){
      if(this.$page.props.providers.data.filter(el => el.id == newState).length)
      {
        this.current_provider = this.$page.props.providers.data.filter(el => el.id == newState)[0];
        this.ProviderName = this.current_provider.name;
        this.ProviderCountry = this.current_provider.country_code;
        this.PostalCode = this.current_provider.postal_code;
        this.City = this.current_provider.city;
        this.Street = this.current_provider.street;
        this.logo = this.current_provider.logo;
        this.leaveProviderFormIdentifier = this.current_provider.identifier;
      } else {
        this.current_provider = null;
        this.ProviderName = [];
        this.logo = null;
        this.leaveProviderFormIdentifier = null;
      }
    }
  },
  methods:{
    leaveProvider(){
      this.form.post(route('user.leave-provider', this.leaveProviderFormIdentifier), {
        onSuccess: () => {
          this.toggleModal();
        },
        onError: (err) => {
          this.toggleModal();
        }
      });
    }
  }
}
</script>
